<template>
  <div class="recipient-groups">
    <transition name="slide" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'RecipientGroups'
}
</script>

<style lang="scss" scoped>

</style>
